import { render, staticRenderFns } from "./usercard.vue?vue&type=template&id=d5b3dcdc&scoped=true&"
import script from "./usercard.vue?vue&type=script&lang=js&"
export * from "./usercard.vue?vue&type=script&lang=js&"
import style0 from "./usercard.vue?vue&type=style&index=0&id=d5b3dcdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b3dcdc",
  null
  
)

export default component.exports